import React from 'react';
import { Spinner } from '../../components/ui';
import InviteCard from './InviteCard';

// Desktop guest invitation page — centered card, no app shell (public route).
export default function InviteDesktop({ vm }) {
  const {
    step, mobile, setMobile, otp, setOtp, busy, err, sent, loading,
    invites, groups, guestName, sendCode, verify, resend, restart,
  } = vm;

  return (
    <div className="center-screen" style={{ alignItems: 'flex-start', paddingTop: 40 }}>
      <div className="card" style={{ width: '100%', maxWidth: 560 }}>
        <div className="card-pad">
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <div style={{ fontSize: 24, fontWeight: 800, color: 'var(--brand)' }}>You're Invited 🎉</div>
            <div className="muted" style={{ fontSize: 13, marginTop: 4 }}>
              {step === 'invites' ? (guestName ? `Welcome, ${guestName}` : 'Your invitations')
                : 'View your invitation & RSVP'}
            </div>
          </div>

          {step === 'mobile' && (
            <form onSubmit={(e) => { e.preventDefault(); sendCode(); }} style={{ maxWidth: 360, margin: '0 auto' }}>
              <label className="field">Your Mobile Number
                <input type="tel" maxLength={10} value={mobile} placeholder="10-digit mobile"
                  onChange={(e) => setMobile(e.target.value)} autoFocus />
              </label>
              {err && <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 10 }}>{err}</div>}
              <button className="btn primary" style={{ width: '100%' }} disabled={busy}>
                {busy ? 'Sending…' : 'Send OTP on WhatsApp'}
              </button>
            </form>
          )}

          {step === 'otp' && (
            <form onSubmit={(e) => { e.preventDefault(); verify(); }} style={{ maxWidth: 360, margin: '0 auto' }}>
              <div className="muted" style={{ fontSize: 13, marginBottom: 12, textAlign: 'center' }}>
                {!sent ? 'Sending…' : vm.reused ? `Use the OTP already sent to WhatsApp ${mobile} — it is valid for 1 hour` : `OTP sent to WhatsApp ${mobile} (valid 1 hour)`}
              </div>
              <label className="field">4-digit OTP
                <input type="tel" maxLength={4} value={otp} onChange={(e) => setOtp(e.target.value)} autoFocus />
              </label>
              {err && <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 10 }}>{err}</div>}
              <button className="btn primary" style={{ width: '100%' }} disabled={busy}>
                {busy ? 'Verifying…' : 'Verify & View Invitation'}
              </button>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 12 }}>
                <button type="button" className="btn light sm" onClick={resend}>Resend OTP</button>
                <button type="button" className="btn light sm" onClick={restart}>Change number</button>
              </div>
            </form>
          )}

          {step === 'invites' && (
            loading ? <Spinner label="Loading your invitations…" />
              : invites.length === 0 ? (
                <div className="empty">
                  No invitations found for {mobile}.
                  <div style={{ marginTop: 10 }}>
                    <button className="btn light sm" onClick={restart}>Try another number</button>
                  </div>
                </div>
              ) : (
                <div>
                  {groups.map(g => (
                    <div key={g.EventId} style={{ marginBottom: 18 }}>
                      <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 8 }}>
                        {g.EventName}{g.EventType ? <span className="muted" style={{ fontWeight: 400, fontSize: 13 }}> · {g.EventType}</span> : null}
                      </div>
                      {g.rows.map(row => (
                        <InviteCard key={row.GuestId} vm={vm} row={row} />
                      ))}
                    </div>
                  ))}
                  <div style={{ textAlign: 'center', marginTop: 8 }}>
                    <button className="btn light sm" onClick={restart}>Use a different number</button>
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    </div>
  );
}
